/* beef-anatomy.js — los cortes del toro (8-sep-2026).
   Spec: docs/superpowers/specs/2026-09-08-beef-anatomy-v3-design.md

   Tres cosas, y nada más:
   1. DESTELLO. Cada 2.6–4 s elige un corte al azar (distinto del anterior),
      le pone `.is-glint` 1.4 s (el CSS dibuja el contorno y lo funde) y lo
      quita. Se para cuando el panel no está en pantalla, la pestaña está
      oculta, hay un corte activo o el usuario pide menos movimiento. Un solo
      `timer`: nunca hay dos esperas encadenadas.
   2. ACTIVO. Un corte a la vez. En dispositivos con hover, pointerenter /
      pointerleave; en táctil, el tap enseña y un pointerdown fuera del SVG
      limpia; con teclado, focus / blur y Escape.
      CLIC (Robert, 18-sep — hasta entonces no hacía nada): si el corte tiene
      producto es un <a> y el clic va a su ficha. En táctil el primer tap solo
      enseña la etiqueta (preventDefault) y el segundo deja pasar el enlace;
      sin producto el tap alterna como siempre y el clic con ratón no hace nada.
   3. PÍLDORA. Una sola. Se centra en el corte activo con getBoundingClientRect
      (incluye el translate del <g> y cualquier scale de reveal.js) y se acota
      con sus medidas reales para no salirse del panel — importa en móvil, donde
      la píldora es el 38% del ancho de la caja. Si el corte trae `data-photo`
      crece a etiqueta con la foto, el producto y el precio (`.has-photo`), y
      con enlace enseña la flecha (`.has-link`). Idea de Maiko, 18-sep.

   Sin este script la sección se ve entera: el CSS pinta el activo con :hover /
   :focus-visible. Aquí no hay GSAP: la sección dejó de cargarlo el 8-sep.
   `shopify:section:load` re-inicializa la sección en el editor de temas y
   `shopify:section:unload` la desmonta (patrón de reveal.js). */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HOVER = window.matchMedia('(hover: hover)');
  var GLINT_MS = 1400;
  var WAIT_MIN_MS = 2600;
  var WAIT_MAX_MS = 4000;
  var DEBUG = /[?&]anatomy=debug\b/.test(location.search);

  function init(section) {
    if (section.__anatomy) section.__anatomy.destroy();
    var media = section.querySelector('[data-anatomy-media]');
    var svg = section.querySelector('[data-anatomy-cuts]');
    var tip = section.querySelector('[data-anatomy-tip]');
    var tipText = section.querySelector('[data-anatomy-tip-text]');
    if (!media || !svg || !tip || !tipText) return;
    var cuts = Array.prototype.slice.call(svg.querySelectorAll('.anatomy__cut'));
    if (!cuts.length) return;
    var tipImg = section.querySelector('[data-anatomy-tip-img]');
    var tipSub = section.querySelector('[data-anatomy-tip-sub]');
    var tipProduct = section.querySelector('[data-anatomy-tip-product]');
    var tipPrice = section.querySelector('[data-anatomy-tip-price]');
    var preloaded = false;

    var active = null;
    var glinting = null;
    var lastGlint = null;
    var timer = 0;
    var inView = false;
    var dead = false;
    var debug = { glints: 0, last: null };
    if (DEBUG) window.__anatomyDebug = debug;

    /* ---- destello ---- */
    function clearGlint() {
      if (glinting) {
        glinting.classList.remove('is-glint');
        glinting = null;
      }
    }
    function stop() {
      clearTimeout(timer);
      timer = 0;
      clearGlint();
    }
    function canGlint() {
      return inView && !active && !document.hidden && !REDUCED.matches && !dead;
    }
    function schedule() {
      clearTimeout(timer);
      timer = 0;
      if (!canGlint()) return;
      var wait = WAIT_MIN_MS + Math.random() * (WAIT_MAX_MS - WAIT_MIN_MS);
      timer = setTimeout(glint, wait);
    }
    function glint() {
      timer = 0;
      if (!canGlint()) return;
      var pool = cuts.length > 1 ? cuts.filter(function (c) { return c !== lastGlint; }) : cuts;
      var pick = pool[Math.floor(Math.random() * pool.length)];
      clearGlint();
      glinting = pick;
      lastGlint = pick;
      pick.classList.add('is-glint');
      debug.glints += 1;
      debug.last = pick.getAttribute('data-cut');
      timer = setTimeout(function () {
        clearGlint();
        schedule();
      }, GLINT_MS);
    }

    /* ---- píldora ----
       Va FUERA del corte, nunca encima: centrada en el corte tapaba justo lo
       que se quiere enseñar (lo vio Robert el 11-sep — en cortes pequeños como
       Vacío o Costilla la etiqueta cubría la zona roja entera).

       Se prueban cuatro colocaciones en orden —arriba, abajo, derecha,
       izquierda— y se toma la primera que quepa dentro del panel sin pisar la
       caja del corte. Si no cabe ninguna (cortes enormes como Rib), se deja
       arriba y se acota: con el corte tan grande la etiqueta tapa una parte
       pequeña en proporción. */
    function placeTip(cut) {
      var path = cut.querySelector('path');
      if (!path) return;
      var m = media.getBoundingClientRect();
      var r = path.getBoundingClientRect();
      if (!m.width || !m.height) return;

      var tw = tip.offsetWidth, th = tip.offsetHeight;
      var GAP = 10, EDGE = 6;
      /* centro del corte, en px relativos al panel */
      var mx = r.left + r.width / 2 - m.left;
      var my = r.top + r.height / 2 - m.top;
      var top = r.top - m.top, bottom = r.bottom - m.top;
      var left = r.left - m.left, right = r.right - m.left;

      var cand = [
        { x: mx, y: top - GAP - th / 2 },          // arriba
        { x: mx, y: bottom + GAP + th / 2 },       // abajo
        { x: right + GAP + tw / 2, y: my },        // derecha
        { x: left - GAP - tw / 2, y: my }          // izquierda
      ];
      var pick = null;
      for (var i = 0; i < cand.length; i++) {
        var c = cand[i];
        var cabe = c.x - tw / 2 >= EDGE && c.x + tw / 2 <= m.width - EDGE &&
                   c.y - th / 2 >= EDGE && c.y + th / 2 <= m.height - EDGE;
        if (cabe) { pick = c; break; }
      }
      if (!pick) pick = { x: mx, y: top - GAP - th / 2 };

      /* acotar al panel pase lo que pase */
      var x = Math.min(Math.max(pick.x, tw / 2 + EDGE), m.width - tw / 2 - EDGE);
      var y = Math.min(Math.max(pick.y, th / 2 + EDGE), m.height - th / 2 - EDGE);
      tip.style.setProperty('--tip-x', (x / m.width * 100).toFixed(2) + '%');
      tip.style.setProperty('--tip-y', (y / m.height * 100).toFixed(2) + '%');
    }

    /* ---- etiqueta con foto ----
       Si el corte trae `data-photo` (setting `product` del block) la píldora
       crece a mini-card con la foto, el producto y el precio; con enlace enseña
       la flecha. Las fotos se precargan cuando el panel asoma en pantalla: son
       las de 300px (~28 miniaturas) para que el primer hover no espere. */
    function preload() {
      if (preloaded) return;
      preloaded = true;
      var seen = {};
      cuts.forEach(function (cut) {
        var src = cut.getAttribute('data-photo');
        if (!src || seen[src]) return;
        seen[src] = true;
        var img = new Image();
        img.decoding = 'async';
        img.src = src;
      });
    }
    function fillTip(cut) {
      var name = cut.getAttribute('aria-label') || '';
      var photo = cut.getAttribute('data-photo') || '';
      var product = cut.getAttribute('data-product') || '';
      /* si la zona y el producto se llaman igual (Ribeye / Ribeye) sobra uno */
      if (product.toLowerCase() === name.toLowerCase()) product = '';
      var price = cut.getAttribute('data-price') || '';
      tipText.textContent = name;
      tip.classList.toggle('has-link', cut.hasAttribute('href'));
      if (photo && tipImg) {
        if (tipImg.getAttribute('src') !== photo) tipImg.src = photo;
        /* producto y precio en spans separados: en móvil recorta el nombre
           ("Rib Short Ribs (Costilla) (6-9 Ri…") y el precio se queda entero */
        tipProduct.textContent = product;
        tipPrice.textContent = product && price ? '· ' + price : price;
        tip.classList.add('has-photo');
      } else {
        tip.classList.remove('has-photo');
        if (tipProduct) tipProduct.textContent = '';
        if (tipPrice) tipPrice.textContent = '';
      }
    }

    /* ---- activo ---- */
    function activate(cut) {
      if (active === cut) return;
      if (active) active.classList.remove('is-active');
      stop();
      active = cut;
      cut.classList.add('is-active');
      fillTip(cut); /* antes de placeTip: la etiqueta con foto mide distinto */
      placeTip(cut);
      tip.classList.add('is-visible');
    }
    function deactivate() {
      if (!active) return;
      active.classList.remove('is-active');
      active = null;
      tip.classList.remove('is-visible');
      schedule();
    }

    function onEnter(e) {
      if (HOVER.matches) activate(e.currentTarget);
    }
    function onLeave(e) {
      if (HOVER.matches && active === e.currentTarget) deactivate();
    }
    /* Clic (Robert, 18-sep). Con ratón el corte-enlace navega solo y el corte
       sin producto no hace nada. En táctil el primer tap enseña la etiqueta
       (se frena el enlace) y el segundo, con el corte ya activo, deja pasar la
       navegación; sin enlace el tap alterna como siempre. */
    function onClick(e) {
      if (HOVER.matches) return;
      var cut = e.currentTarget;
      if (active === cut) {
        if (!cut.hasAttribute('href')) deactivate();
        return;
      }
      if (cut.hasAttribute('href')) e.preventDefault();
      activate(cut);
    }
    /* Solo el foco VISIBLE activa (Tab). Un tap o un clic de ratón también
       enfocan el <g tabindex=0>, pero sin :focus-visible: si el foco activara
       siempre, en táctil el primer tap encendía el corte por `focus` y el
       `click` que llega detrás lo apagaba — el tap parecía no hacer nada. */
    function onFocus(e) {
      var cut = e.currentTarget;
      var visible = true;
      try { visible = cut.matches(':focus-visible'); } catch (err) { /* navegador sin :focus-visible → foco = activar */ }
      if (visible) activate(cut);
    }
    function onBlur(e) {
      if (active === e.currentTarget) deactivate();
    }
    function onKey(e) {
      if (e.key === 'Escape' && active) {
        var was = active;
        deactivate();
        if (document.activeElement === was) was.blur();
      } else if (e.key === ' ' && e.target && e.target.classList && e.target.classList.contains('anatomy__cut')) {
        e.preventDefault(); /* que la barra no haga scroll con un corte enfocado */
      }
    }
    function onOutside(e) {
      if (active && !svg.contains(e.target)) deactivate();
    }
    function onVisibility() {
      if (document.hidden) stop();
      else schedule();
    }
    function onMotion() {
      if (REDUCED.matches) stop();
      else schedule();
    }

    cuts.forEach(function (cut) {
      cut.addEventListener('pointerenter', onEnter);
      cut.addEventListener('pointerleave', onLeave);
      cut.addEventListener('click', onClick);
      cut.addEventListener('focus', onFocus);
      cut.addEventListener('blur', onBlur);
    });
    section.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onOutside);
    document.addEventListener('visibilitychange', onVisibility);
    if (REDUCED.addEventListener) REDUCED.addEventListener('change', onMotion);

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) {
          preload();
          schedule();
        } else {
          stop();
        }
      }, { threshold: 0.3 });
      io.observe(media);
    } else {
      inView = true;
      preload();
      schedule();
    }

    section.__anatomy = {
      destroy: function () {
        dead = true;
        stop();
        deactivate();
        cuts.forEach(function (cut) {
          cut.removeEventListener('pointerenter', onEnter);
          cut.removeEventListener('pointerleave', onLeave);
          cut.removeEventListener('click', onClick);
          cut.removeEventListener('focus', onFocus);
          cut.removeEventListener('blur', onBlur);
        });
        section.removeEventListener('keydown', onKey);
        document.removeEventListener('pointerdown', onOutside);
        document.removeEventListener('visibilitychange', onVisibility);
        if (REDUCED.removeEventListener) REDUCED.removeEventListener('change', onMotion);
        if (io) io.disconnect();
        section.__anatomy = null;
      }
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-beef-anatomy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('[data-beef-anatomy]');
    if (section && section.__anatomy) section.__anatomy.destroy();
  });
})();
